import { useSelector } from 'react-redux';
import { getAuthLang } from 'store/selectors';
import { getNoun } from 'utils/plural-ru';
import { sliceTimestamp } from 'utils/sliceTimestamp';
import { useTranslator } from 'utils/translator';

const useGetTimePassedAfterTransaction = (timestamp, maxParts = 3) => {
  timestamp = parseInt(sliceTimestamp(timestamp));

  const { t } = useTranslator();

  const isRussian = useSelector(getAuthLang) === 'ru';

  const currentUnixTimestamp = Math.floor(Date.now() / 1000);
  let timeDifference = currentUnixTimestamp - timestamp;

  const units = [
    { label: 'historyYear', seconds: 31536000 },
    { label: 'historyMonth', seconds: 2592000 },
    { label: 'historyDay', seconds: 86400 },
    { label: 'historyHour', seconds: 3600 },
    { label: 'historyMinute', seconds: 60 },
    { label: 'historySecond', seconds: 1 },
  ];

  if (timeDifference < 0) {
    return ''; // Time is not correct
  }

  if (maxParts > units.length) {
    return ''; // Too many parts
  }

  const dateParts = units.reduce((acc, unit) => {
    if (maxParts <= 0) {
      return acc;
    }

    const value = Math.floor(timeDifference / unit.seconds);
    timeDifference %= unit.seconds;

    if (value > 0) {
      let unitLabel;

      if (isRussian) {
        unitLabel = getNoun(value, t(unit.label), ...(t(`${unit.label}Affix`) || []));
      } else {
        unitLabel = `${t(unit.label)}${value > 1 ? t(`${unit.label}Affix`) : ''}`;
      }

      acc.push(`${value} ${unitLabel}`);
      --maxParts;
    }

    return acc;
  }, []);

  return dateParts.join(' ');
};

export default useGetTimePassedAfterTransaction;
